import { Input } from 'components/form';
import { debounce } from 'lodash';
import React, { ChangeEventHandler } from 'react';

type DebounceSearchProps = {
  type: 'number' | 'text' | 'email' | 'password';
  name: string;
  onSearch: (value: string) => void;
  debounceTimeout?: number;
  showError?: boolean;
};
const DebounceSearch = (props: DebounceSearchProps) => {
  const { type, name, onSearch, debounceTimeout = 200, showError = false } = props;
  const debounceFetcher = React.useMemo(() => {
    const loadOptions: ChangeEventHandler<HTMLInputElement> = (event) => {
      onSearch(event.target.value);
    };

    return debounce(loadOptions, debounceTimeout);
  }, [debounceTimeout, onSearch]);

  return <Input showError={showError} type={type} name={name} onChange={debounceFetcher} />;
};

export default DebounceSearch;
